import {
  MATERIAL_STOCK_LOT_ALL,
  MATERIAL_STOCK_LOT_GET,
  MATERIAL_STOCK_LOT_DEL,
  MATERIAL_STOCK_LOT_PUT,
  MATERIAL_STOCK_LOT_POST,
  MATERIAL_STOCK_LOT_LOADING,
  MATERIAL_STOCK_LOT_ERROR,
  MATERIAL_STOCK_LOT_DECREASE,
  MATERIAL_STOCK_LOT_INCREASE,
} from '../../actions/types';

const initialState = {
  materialStockLot: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case MATERIAL_STOCK_LOT_LOADING:
      return { isLoading: true, isCompleted: true };
    case MATERIAL_STOCK_LOT_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case MATERIAL_STOCK_LOT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MATERIAL_STOCK_LOT_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MATERIAL_STOCK_LOT_POST:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_STOCK_LOT_DECREASE:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_STOCK_LOT_INCREASE:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_STOCK_LOT_PUT:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_STOCK_LOT_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
